<script>
import axios from "axios";
  export default {
    mounted(){
      // @TODO - Switch to API call from Sync for redundant backup, and use the direct data load for initial, but this will at least get us MVP in the interim
      //this.getStore();
      //console.log(window.store_meta_data);
      if(window.store_meta_data){
        this.assignStoreData();
        //this.store = window.store_meta_data;
        this.checkActiveStore();
      }
    },
    watch: {
      'store.store_id'(){
        // could pass newVal with INT?
          this.getApiData();
      }
    },
    methods: {
      // @TODO - Add @click handler to quote buttons and create method to trigger the modal opening onclick call through Vue
      assignStoreData(){
        const vm = this;
        let data = window.store_meta_data;
        Object.entries(data).forEach(function([$key,$value]){
          vm.store[$key] = $value;
        });

      },
      checkActiveStore(){
        // Check Cookie for userTwStore
        // If has -> process against data
        if(this.getCookie('userTwStore')){
          let store_id = parseInt(this.getCookie('userTwStore'));
          if(store_id === parseInt(this.store.store_id)){
            this.my_store = true;
          }
        }
      },
      getCookie(cname){
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return false;
      },
      setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        let expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
      },
      openQuoteModal(){
        if(typeof(window.tintworldVue) !== 'undefined' && typeof(window.tintworldVue.$root) !== 'undefined'){
          window.tintworldVue.$root.$store.commit('OpenModal','quote');
          window.tintworldVue.$root.$emit('bv::show::modal','tint-world-modal');
        }
      },
      setMyStore(){
        if(typeof(window.tintworldVue) !== 'undefined' && typeof(window.tintworldVue.$root) !== 'undefined'){
          this.my_store = true;
          window.tintworldVue.$root.$children[0].updateStoreLocation(this.store.store_id);
          this.setCookie('userTwStore',this.store.store_id, 7);
        }
      },
      getApiData(){
        const vm = this;
        let store_id;
        if(vm.store.franconnect_id !== null){
          store_id = vm.store.franconnect_id;
        }
        if(vm.store.store_id !== null){
          store_id = vm.store.store_id;
        }
        axios.get('https://sync.tintworld.com/api/v4/store/'+parseInt(store_id), {
      }).then(function(response) {
          let data = response.data.data;
          if(data.attributes){
            if(typeof(data.attributes.street_2) !== 'undefined'){
              vm.store.address2 = data.attributes.street_2;
            }
            if(typeof(data.attributes.google_place_id) !== 'undefined'){
              vm.store.google_place = data.attributes.google_place_id;
            }
            if(typeof(data.attributes.store_display_number) !== 'undefined'){
              vm.store.display_phone = data.attributes.store_display_number;
            }
            if(typeof(data.attributes.facebook_url) !== 'undefined'){
              vm.store.facebook_url = data.attributes.facebook_url;
            }
            if(typeof(data.attributes.instagram_url) !== 'undefined'){
              vm.store.instagram_url = data.attributes.instagram_url;
            }
            if(typeof(data.attributes.landing_page_url) !== 'undefined'){
              vm.store.store_url = data.attributes.landing_page_url;
            }
            if(typeof(data.attributes.map_image) !== 'undefined'){
              vm.store.map_image = data.attributes.map_image;
            }
            if(typeof(data.attributes.store_phone) !== 'undefined'){
              vm.store.phone_international = data.attributes.store_phone;
            }
          }
        });
      },
      getStore(){
        const vm = this;
        axios.get('https://www.tintworld.com/wp-json/tint-world-api/v1/get-store-by-id/002').then(function(response){
          let storeData = response.data.postData;
          let meta = response.data.meta;
          if(typeof(storeData.ID) !== 'undefined'){
            vm.store.post_id = storeData.ID;
          }
          if(typeof(meta['wpcf-city-name']) !== 'undefined'){
            vm.store.city = meta['wpcf-city-name'][0];
          }
          if(typeof(meta['wpcf-full-address']) !== 'undefined'){
            vm.store.full_address = meta['wpcf-full-address'][0];
          }
          if(typeof(meta['wpcf-postal-code']) !== 'undefined'){
            vm.store.postal_code = meta['wpcf-postal-code'][0];
          }
          if(typeof(meta['wpcf-region']) !== 'undefined'){
            vm.store.state = meta['wpcf-region'][0];
          }
          if(typeof(meta['wpcf-region-code']) !== 'undefined'){
            vm.store.region_code = meta['wpcf-region-code'][0];
          }
          if(typeof(meta['wpcf-local-areas']) !== 'undefined'){
            vm.store.local_areas = meta['wpcf-local-areas'][0];
          }
          if(typeof(meta['wpcf-store-tour']) !== 'undefined'){
            vm.store.store_tour = meta['wpcf-store-tour'][0];
          }
          if(typeof(meta['wpcf-store-video']) !== 'undefined'){
            vm.store.store_video = meta['wpcf-store-video'][0];
          }
          if(typeof(meta['wpcf-street-name']) !== 'undefined'){
            vm.store.address = meta['wpcf-street-name'][0];
          }
          if(typeof(meta['wpcf-store-number']) !== 'undefined'){
            vm.store.store_id = meta['wpcf-store-number'][0];
          }
          if(typeof(meta['wpcf-store-phone-number']) !== 'undefined'){
            vm.store.phone = meta['wpcf-store-phone-number'][0];
          }
          if(typeof(meta['wpcf-franconnect-store-code']) !== 'undefined'){
            vm.store.franconnect_id = meta['wpcf-franconnect-store-code'][0];
          }
          if(typeof(meta['wpcf-google-place']) !== 'undefined' && meta['wpcf-google-place'][0] !== ''){
            vm.store.google_place = meta['wpcf-google-place'][0];
          }
          if(typeof(response.data.responseCode) !== 'undefined' && response.data.responseCode == 1){
            vm.store.store_url = response.data.permalink;
          }

        });
      },
      myStoreToggle(){
        this.my_store = true;
        this.setMyStore();
      }
    },
    data(){
      return {
        store: {
          post_id: null,
          franconnect_id: null,
          store_id: null,
          store_url: null,
          address: null,
          address2: null,
          city: null,
          state: null,
          phone: null, // set as default 1-800 number
          region_code: null,
          full_address: null,
          postal_code: null,
          google_place: null,
          hours: 'Mon - Sat: 8am - 6pm <br/> <div class="em">Closed Sundays</div>',
          store_tour: null,
          local_areas: null,
          display_phone: null,
          instagram_url: null,
          facebook_url: null,
          map_image: null,
          phone_international: null
        },
        toggle: false,
        my_store: false,
      }
    },
    computed: {
      showToggle(){
        if(this.hasStoreTour){
          return true;
        }
        return false;
      },
      fullAddress(){
        if(this.store.full_address !== null){
          return this.store.full_address;
        }
        if(this.store.address !== null){
          return this.store.address + ' '+ this.store.address2+ ' '+ this.store.city + ', '+ this.store.state + ' '+ this.store.postal_code;
        }
        return ''
      },
      hasMap(){
        return this.googleMap !== '';
      },
      hasStoreTour(){
        if(this.store.store_tour == ''){
          return false;
        }
        if(this.store.store_tour !== null){
          return true;
        }
        return false;
      },
      hasGooglePlace(){
        if(typeof this.store.google_place == 'undefined'){
          return false;
        }
        return this.store.google_place !== null;
      },
      googleMap(){
        if(this.hasGooglePlace){
          return 'https://www.google.com/maps/embed/v1/place?key=AIzaSyB7D6J6Fq90RlWi2TdWsl_ogZn5oHPZuJ0&q=place_id:'+encodeURIComponent(this.store.google_place);
        }
        if(this.store.full_address !== null) {
          return 'https://www.google.com/maps/embed/v1/place?key=AIzaSyB7D6J6Fq90RlWi2TdWsl_ogZn5oHPZuJ0&q='+encodeURIComponent("Tint World"+this.store.full_address);
        }
        return false;
      },
      directionsUrl(){
        if(this.store.franconnect_id == null){
          return '';
        }
        return 'https://sync.tintworld.com/api/cache/store-directions?store_id='+encodeURIComponent(this.store.franconnect_id);
      },
      callablePhone(){
        if(this.store.phone_international !== null){
          return this.store.phone_international;
        }
        return '+18007678468';
      },
      displayPhone(){
        if(this.store.display_phone !== null){
          return this.store.display_phone;
        }
        if(this.store.phone !== null){
          return this.store.phone;
        }
        if(this.store.phone_international !== null){
          return this.store.phone_international;
        }
        return '1.800.767.8468';
      },
    },

  }
</script>

<template>
  <section id="store-info-module">
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-6">
          <div id="mapDiv1" class="store-map-ctn" v-if="!toggle && googleMap">
            <!-- @TODO - Should likely use a suspense / lazy loader animation -->
            <iframe :src="googleMap" width="100%" height="350" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          </div>
          <!-- @TODO - Add conditional logic where we'll disable the toggle or load fallback content as needed -->
          <div id="store-tour-container" v-if="toggle" v-html="store.store_tour"></div>
          <!-- @TODO - Add conditional logic where we'll disable the toggle or load fallback content as needed -->
          <div class="row text-center my-3" v-if="hasStoreTour">
            <div class="col-4 storeToggle1 storeToggleDown text-right m-0 p-0 custom-toggle" id="toggleText1" :class="{'tab-active':!toggle}">Store Map</div>
            <div class="col-4 m-0 p-0">
              <div class="custom-control custom-switch custom-switch-sm custom-switch-md custom-switch-lg custom-switch-xl">
                <input type="checkbox" class="custom-control-input" id="customSwitch1" v-model="toggle">
                <label class="custom-control-label" for="customSwitch1"></label>
              </div>
            </div>
            <div class="col-4 storeToggle1 storeToggleUp text-left m-0 p-0 custom-toggle" id="toggleText2" :class="{'tab-active':toggle}">Store Tour</div>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="row mx-3">
            <div class="col-3 text-right">
              <div class="heart-area c-pointer" @click="myStoreToggle" :class="{'active':my_store}">
                <i aria-hidden="true" class="fa fa-heart-o"></i>
                <p v-if="!my_store">Set as</p>
                <p>My<br>Store</p>
              </div>
            </div>
            <div class="col-9 xpadding"><span class="storeTitle2">{{this.store.city}}, {{this.store.region_code}}</span> <span class="storeText1 noWrap">(Store #{{this.store.store_id}})</span>
              <div class="storeText2 mt-1">
                <i class="fas fa-phone-alt"></i>
                <a class="ml-2" :href="'tel:'+callablePhone">{{this.displayPhone}}</a></div>
              <div class="storeText2 mt-1 d-flex align-items-center">
                <i class="fas fa-map-marker-alt"></i>
                <div class="ml-2 store-address">{{ fullAddress }}</div>
              </div>
              <div class="ml-2 directLink d-none"><a :href="directionsUrl" target="_blank">Get Directions</a></div>
            </div>
          </div>
          <div class="row storeBorder1 py-3 mt-4 mb-3 mx-3">
            <div class="col-6">
              <div class="storeTitle2">Hours:</div>
              <div class="storeText3">Mon - Sat: <b>8am - 6pm</b></div>
              <div class="directLink">Closed Sundays</div>
            </div>
            <div class="col-6 text-center mt-2">
              <div><a href="#" @click="openQuoteModal" class="submit">Get Quote</a></div>
            </div>
          </div>
          <div class="row mx-3">
            <div class="col-12"><div class="storeTitle2 mb-2">Store Amenities & Specialties:</div></div>
          </div>
          <div class="row mx-3 mb-5">
            <div class="col-6">
              <div class="storeText3 mb-1"><i class="iconColor fas fa-wifi"></i> Free WiFi</div>
              <div class="storeText3 mb-1"><i class="iconColor fas fa-wheelchair"></i> Accessibile</div>
              <div class="storeText3 mb-1"><i class="iconColor fas fa-anchor"></i> Marine Services</div>
              <div class="storeText3 mb-1"><i class="iconColor fas fa-truck"></i> Oversized Vehicles</div>
            </div>
            <div class="col-6">
              <div class="storeText3 mb-1"><i class="iconColor fas fa-coffee"></i> Free Coffee & Snacks</div>
              <div class="storeText3 mb-1"><i class="iconColor fas fa-moon"></i> Overnight Drop-Off</div>
              <div class="storeText3 mb-1"><i class="iconColor fas fa-paw"></i> Pet Friendly</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>

@media(max-width:412px) {
  .title1 { font-size:40px; }
  .subTitle1 { font-size: 20px; }
  .subTitle2 { font-size: 20px; }
  .h2Box { border: none; }
  .submit { font-size: 12px; padding: 5px 15px 8px 15px; }
  #storeAbout .storeText3, #storeAbout .storeText4 { display: none; }
  #storeHeadquarters h2, #PromosMobile h2 { line-height: 38px; }
  .carousel-inner { height: 390px; }
  #PromosMobile .carousel-inner { height: 370px; }
  .storeHeadquarters h4{ padding-top: 20px; }
  .storeBox2 { margin: 40px 0; height: 100%; }
  .installationSubTitle2 { text-align: center; }
  #Promos { height: 550px; }
  .styleBtn1, .styleBtn2 { font-size: 14px; }
  #PromosMobile .storeBox,  #PromosMobile .storeBox2  { width: 85%; margin: 0 auto; }
  .xpadding { padding-left: 30px; }
  .heart-area { width: 60px; height: 60px; }
}
@media(min-width:413px) {
  .title1 { font-size:40px; }
  .subTitle1 { font-size: 20px; }
  .storeTitle2 { font-size: 23px; }
  .h2Box { border: none; }
  .submit { font-size: 14px; padding: 5px 20px 8px 20px; }
  #storeAbout .storeText3, #storeAbout .storeText4 { display: none; }
  #storeHeadquarters h2, #PromosMobile h2 { line-height: 38px; }
  .carousel-inner { height: 390px; }
  #PromosMobile .carousel-inner { height: 370px; }
  .storeHeadquarters h4{ padding-top: 20px; }
  .storeBox2 { margin: 40px 0; height: 100%; }
  .installationSubTitle2 { text-align: center; }
  #Promos { height: 550px; }
  .styleBtn1, .styleBtn2 { font-size: 14px; }
  #PromosMobile .storeBox,  #PromosMobile .storeBox2  { width: 85%; margin: 0 auto; }
  .heart-area { width: 75px; height: 75px; }
}
@media(min-width:601px) {
  .title1 { font-size: 36px; }
  .subTitle1 { font-size: 20px; }
  .storeTitle2 { font-size: 23px; }
  .h2Box { border-bottom: 4px solid #dedede; }
  .submit { font-size: 14px; padding: 5px 15px 8px 15px; }
  .styleBtn1, .styleBtn2 { font-size: 10px; }
  #buyNow img { padding-top: 30px; }
  .storeBox2 { height: 100%; }
  .heart-area { width: 75px; height: 75px; }
}
@media(min-width:768px) {
  .title1 { font-size: 48px; }
  .subTitle1 { font-size: 26px; }
  .storeTitle2 { font-size: 23px; }
  .h2Box { border-bottom: 4px solid #dedede; }
  .heart-area { width: 75px; height: 75px; }
  .xpadding { padding-left: 30px; }
}
@media(min-width:992px) {
  .storeBox2 { height: 100%; }
  .storeTitle2 { font-size: 23px; }
  .heart-area { width: 75px; height: 75px; }
}
@media(min-width: 1200px) {
  .title1 { font-size: 52px; }
  .subTitle1 { font-size: 28px; }
  .storeTitle2 { font-size: 23px; }
  .h2Box { border-bottom: 6px solid #dedede; }
  .submit { font-size: 20px; padding: 5px 35px 8px 35px; }
  .carousel-inner { height: 350px; }
  #Promos { height: 500px; }
  .styleBtn1, .styleBtn2 { font-size: 14px; }
  .storeBox2 { height: 100%; }
  .heart-area { width: 75px; height: 75px; }
  }
#storeAbout, #Promos {
  background-color: #222222;
}
#storeHeadquarters, #buyNow {
  background-color: #ffe300;
}
#storeHeadquarters h2, #storeHeadquarters h4, #storeHeadquarters h2, #storeHeadquarters h3, #addServices h2, #addServices h3, #PromosMobile h2, #PromosMobile h3 {
  color: #000;
}
#storeHeadquarters h3, #storeHeadquarters p, #addServices h3, #PromosMobile h3  {
  color: #444444;
}
.storeTitle3, #storeAbout .storeText3, .subTitle2, #storeAbout h2, #storeAbout h3, #Promos h2, #Promos p {
  color: #FFF;
}
.subTitle3, .storeText4, #storeAbout p, #Promos h3 {
  color: #CCC;
}
#addServices, #reviewsTop, #reviews, #reviewsBottom, #PromosMobile, #PromosMobile .addCallout {
  background-color: #f1f1f1;
}
#addServices a, #PromosMobile a {
  color: #028aff;
}
.store-address, .storeText2 {
  font-size: 14px;
}
.custom-toggle {
  color: #7c7c7c
}
.heart-area {
  border-radius: 5px;
  border: 2px solid #acacac;
  background: transparent;
  color: #0992f1;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.heart-area.active {
  border: 0 solid #acacac;
  background: #0992f1;
  color: #fff;
}
.heart-area p {
  font-size: 13px;
  margin: 0;
  line-height: 1;
}
.c-pointer {
  cursor: pointer;
}
#store-tour-container {
  max-width: 100%;
  overflow: hidden;
  max-height: 450px;
}
iframe {
  max-height:350px !important;
  height: 350px !important;
}
#addServices {
  padding-top: 30px;
  padding-bottom: 30px;
}
#PromosMobile {
  padding-top: 30px;
  padding-bottom: 25px;
}
.title1 {
  text-transform: uppercase;
  font-weight:700;
  letter-spacing:-2px;
  line-height: 33px;
  color: #111111;
}
.subTitle1 {
  text-transform: uppercase;
  letter-spacing:-1px;
  color: #333;
  line-height: 23px;
}
.h2Box {
  padding-bottom: 30px;
  margin: 30px 0 30px 0;
}
.storeTitle2 {
  font-weight: bold;
}
.storeText1 {
  font-size: 13px;
  color: #555555;
}
.storeText4 {
  font-size: 14px;
  font-style: italic;
}
.storeToggle1 {
  font-size:22px;
  font-weight: bold;
}
.storeBorder1 {
  border-top: 2px solid #dedede;
  border-bottom: 2px solid #dedede;
}
.submit {
  border-radius: 25px;
  background-color: #028bff;
  color: #FFF !important;
  border: none;
  width: 95%;
  font-weight: 700;
  text-transform: uppercase;
}
.iconColor {
  color: #787878;
  padding-right: 5px;
}
#storeAbout {
  padding: 25px;
}
#storeAbout p {
  font-size: 18px;
  line-height: 30px;
}
#storeAbout h2 {
  border-left: 10px solid #ffe300;
  font-weight: 800;
  padding-left: 15px;
  text-transform: uppercase;
  font-size: 42px;
  line-height: 36px;
}
#buyNow h2 {
  border-left: 10px solid #e5cc00;
  font-weight: 800;
  padding-left: 15px;
  text-transform: uppercase;
  font-size: 42px;
  line-height: 36px;
}
#storeAbout h3 {
  font-weight: bold;
  font-size: 22px;
}
#storeAbout {
  padding-top: 50px;
  padding-bottom:30px;
}
#storeHeadquarters {
  padding-top: 30px;
  padding-bottom: 20px;
}
#storeHeadquarters h2, #addServices h2, #PromosMobile h2 {
  font-weight: 800;
  text-transform: uppercase;
  font-size: 42px;
}
#storeHeadquarters h3, #storeHeadquarters p, #addServices h3, #Promos h3, #PromosMobile h3 {
  font-size: 17px;
  font-weight: normal;
}
.storeBox, .storeBox2  {
  border-radius: 15px 15px 15px 15px;
}
.card-Link {
  font-size: 12px;
}
#storeHeadquarters .card-text, #addServices .card-text, #PromosMobile .card-text {
  font-size: 20px;
  font-weight: 800;
}
.card-Link {
  font-size: 14px;
  font-weight: normal;
}
.card-body2 {
  background-color: #191919;
  border-radius: 0 0 15px 15px;
  height: 80px;
}
.styleBtn1 {
  color: #FFF;
  padding:10px;
  border-radius: 10px;
  border: 2px solid #ffe300;
  font-weight: 700;
}
.styleBtn2 {
  color: #000;
  padding:10px;
  border-radius: 10px;
  border: 2px solid #CCC;
  font-weight: 700;
}
#contact-bar {
  padding-top: 20px;
  padding-bottom: 20px;
  background-color: #FFDD00;
}
#Promos {
  padding-top: 35px;
  padding-bottom: 30px;
}
#contact-bar h3.installationSubTitle2 {
  font-size: 26px;
  font-weight: 700;
  text-transform: capitalize;
  margin-top: 5px;
}
#reviewsTop {
  padding-top: 30px;
  padding-bottom: 10px;
}
#contact-bar h3 a {
  color: #028bff;
}
#reviewsTop h2, #Promos h2 {
  text-transform: uppercase;
  font-weight: 800;
  font-size: 48px;
  line-height: 45px;
}
.subTitle {
  font-size: 18px;
}
#buyNow {
  padding-top: 40px;
}
.storeToggleDown, .storeToggleUp {
  transition: color 0.3s ease-in-out;
}
.blackColor {
  color: black !important;
}
.grayColor {
  color: #7c7c7c !important;
}
.custom-toggle.tab-active {
  color: black !important;
}
.carousel-btn-L, .carousel-btn-R  {
  position: absolute;
  color: #FFF;
  top: 140px;
}
.carousel-btn-L {
  left: 40px;
}
.carousel-btn-R {
  right: 40px;
}
.carousel-btn-L {
  left:10px !important;
}
.carousel-btn-R {
  right:10px !important;
}
#storeHeadquarters a, .bottomQuote a, #storeInfo a {
  color: #007bff;
}
#storeHeadquarters a.btn, #PromosMobile a.carousel-btn-L, #PromosMobile a.carousel-btn-R {
  color: #000;
}
.custom-switch.custom-switch-sm .custom-control-label {
  padding-left: 1rem;
  padding-bottom: 1rem;
}

.custom-switch.custom-switch-sm .custom-control-label::before {
  height: 1rem;
  width: calc(1rem + 0.75rem);
  border-radius: 2rem;
}

.custom-switch.custom-switch-sm .custom-control-label::after {
  width: calc(1rem - 4px);
  height: calc(1rem - 4px);
  border-radius: calc(1rem - (1rem / 2));
}

.custom-switch.custom-switch-sm .custom-control-input:checked ~ .custom-control-label::after {
  transform: translateX(calc(1rem - 0.25rem));
}

/* for md */

.custom-switch.custom-switch-md .custom-control-label {
  padding-left: 2rem;
  padding-bottom: 1.5rem;
}

.custom-switch.custom-switch-md .custom-control-label::before {
  height: 1.5rem;
  width: calc(2rem + 0.75rem);
  border-radius: 3rem;
}

.custom-switch.custom-switch-md .custom-control-label::after {
  width: calc(1.5rem - 4px);
  height: calc(1.5rem - 4px);
  border-radius: calc(2rem - (1.5rem / 2));
}

.custom-switch.custom-switch-md .custom-control-input:checked ~ .custom-control-label::after {
  transform: translateX(calc(1.5rem - 0.25rem));
}

/* for lg */

.custom-switch.custom-switch-lg .custom-control-label {
  padding-left: 3rem;
  padding-bottom: 2rem;
}

.custom-switch.custom-switch-lg .custom-control-label::before {
  height: 2rem;
  width: calc(3rem + 0.75rem);
  border-radius: 4rem;
}

.custom-switch.custom-switch-lg .custom-control-label::after {
  width: calc(2rem - 4px);
  height: calc(2rem - 4px);
  border-radius: calc(3rem - (2rem / 2));
}

.custom-switch.custom-switch-lg .custom-control-input:checked ~ .custom-control-label::after {
  transform: translateX(calc(2rem - 0.25rem));
}

/* for xl */

.custom-switch.custom-switch-xl .custom-control-label {
  padding-left: 4rem;
  padding-bottom: 2.5rem;
}

.custom-switch.custom-switch-xl .custom-control-label::before {
  height: 2.5rem;
  width: calc(4rem + 0.75rem);
  border-radius: 5rem;
}

.custom-switch.custom-switch-xl .custom-control-label::after {
  width: calc(2.5rem - 4px);
  height: calc(2.5rem - 4px);
  border-radius: calc(4rem - (2.5rem / 2));
}

.custom-switch.custom-switch-xl .custom-control-input:checked ~ .custom-control-label::after {
  transform: translateX(calc(2.5rem - 0.25rem));
}
.directLink, .directLink2 {
  font-size:12px;
  font-style: italic;
}
.noWrap {
  white-space: nowrap;
}
</style>